// This file is only a template for actions.  Copy and paste this to your application's actions .ts file and start off from there
// Rename all things with App_Name.
// Naming convention for actions is "[App Name]Actions.ts" i.e. UsersActions.ts, EntitlementActions.ts


import Viewer3DServices from '../viewers/services/Viewer3DServices';
import * as Interfaces from '../Interfaces/Interfaces';
var _requests: any[] = [null, null, null, null];

var Viewer3DActions = {

    getGraphicsInfo(assetObjectListId: string, projectId: string, callback: any): void {
        var graphicsRequest: GraphicsRequestBase = {
            graphicObjectListID: assetObjectListId,
            projectID: projectId
        };
        var indx = 3;
        if (_requests[indx] != null) {
            _requests[indx].abort();
        }
        _requests[indx] = Viewer3DServices.getGraphicalRequestInfo(graphicsRequest,
            function (data: any) {
                if (callback !== undefined) {
                    callback(data);
                }
                _requests[indx] = null;
            }, function (error: any) {
                _requests[indx] = null;
            });
    },

    getOctree(assetObjectListId: string, projectId: string, namedList: Interfaces.Interfaces.OverrideNamedList[], callback: any): void {
        var graphicsRequest: OctreeRequest = {
            
            graphicObjectListID: assetObjectListId,
            projectID: projectId
        };
        var indx = 0;


        while (_requests[indx] != null) {
            indx++;
        }
        _requests[indx] = Viewer3DServices.getOctree(graphicsRequest,
            function (data: any) {
                if (callback !== undefined) {
                    callback(data);
                }
                _requests[indx] = null;
            }, function (error: any) {
                _requests[indx] = null;
            });
    },
    getAssetSetOctrees(assetSetIDs: string[], callback: any): void {
        var graphicsRequest: any = {
            
            assetSetIDs: assetSetIDs
        };
        var indx = 0;


        while (_requests[indx] != null) {
            indx++;
        }
        _requests[indx] = Viewer3DServices.getAssetSetOctrees(graphicsRequest,
            function (data: any) {
                if (callback !== undefined) {
                    callback(data);
                }
                _requests[indx] = null;
            }, function (error: any) {
                _requests[indx] = null;
            });
    },


    getGraphics(assetObjectListId: string, projectId: string, namedList: Interfaces.Interfaces.OverrideNamedList[], startIndex: number, maxCount: number, callback: any): void {
        var graphicsRequest: GraphicsRequest = {
            graphicObjectListID: assetObjectListId,
            projectID: projectId,
            appearancesOverrideModel: namedList,
            maxResults: maxCount,
            startIndex: startIndex
        };
        var indx = 0;

        
        while (_requests[indx] != null) {
            indx++;
        }
        _requests[indx] = Viewer3DServices.getGraphics(graphicsRequest,
            function (data: any) {
                if (callback !== undefined) {
                    callback(data);
                }
                _requests[indx] = null;
            }, function (error: any) {
                _requests[indx] = null;
            });
    },

    getLODGraphicsUrl() {
        return Viewer3DServices.getLodDataRequestUrl();
    },
    getOctreeGraphicsUrl() {
        return Viewer3DServices.getGraphicDataOctreeRequestUrl();
    },

    getGraphicsURL() {
        return Viewer3DServices.getGraphicDataRequestUrl();
    },

    getAppearances(ontologyId: string, callback?: any): void {
        var appearanceReq = { ontologyId: ontologyId };
        var indx = 1;
        if (_requests[indx] != null) {
            _requests[indx].abort();
        }
        _requests[indx] = Viewer3DServices.getAppearances(appearanceReq,
            function (data: any) {
                if (callback !== undefined) {
                    callback(data);
                }
                _requests[indx] = null;
            }, function (error: any) {
                _requests[indx] = null;
            });
    },
    getObjectExtents(projectId: string, objectIds: string[], markedPointIds : string[], callback?: any) {
        
        var extentRequest: ExtentRequest = {
            projectID: projectId,
            hierarchyItemIDs: objectIds,
            markedPointIDs: markedPointIds
        }

        var indx = 3;

        if (_requests[indx] != null) {
            _requests[indx].abort();
        }

        Viewer3DServices.getObjectExtents(extentRequest,
            function (data: any) {
                if (callback !== undefined) {
                    callback(data);
                }
                _requests[indx] = null;
            }, function (error: any) {
                _requests[indx] = null;

            });
    },
    getGraphicAppearance(graphicObjectListId: string, projectId: string, namedList: Interfaces.Interfaces.OverrideNamedList[], callback?: any) {
        var graphicsRequest: GraphicsRequest = {
            projectID: projectId,
            graphicObjectListID: graphicObjectListId,
            appearancesOverrideModel: namedList
        }

        var indx = 2;
        if (_requests[indx] != null) {
            _requests[indx].abort();
        }

        Viewer3DServices.getGraphicAppearance(graphicsRequest,
            function (data: any) {
                if (callback !== undefined) {
                    callback(data);
                }
                _requests[indx] = null;
            }, function (error: any) {
                _requests[indx] = null;

            });
    },

    
    clearRequests(): void {
        for (var req in _requests) {
            if (_requests[req] != null) {
                _requests[req].abort();
            }
        }
    }
}

export default Viewer3DActions;